import styled from 'styled-components';

import GateKeepingListItem from './GateKeepingListItem';

import { listItemStyles } from 'modules/fleet/list';

export default styled(GateKeepingListItem)`
  ${listItemStyles}
`;
